import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
const PageContext = createContext();

export const PageProvider = ({ children }) => {
    const [pages, setPages] = useState([]);
    // You can have a single state object for user attributes
    const [page, setPage] = useState({});
   
  
  
  
    const setPageAttributes = (attributes) => {
      // Merge the new attributes with the existing ones
      setPage((prevPage) => ({ ...prevPage, ...attributes }));
     

    };

  
    return (
      <PageContext.Provider value={{ setPages, pages, page, setPageAttributes , setPage  }}>
        {children}
      </PageContext.Provider>
    );
  };
  PageProvider.propTypes={
    children:PropTypes.node.isRequired
  }
  
  export const usePage = () => {
    return useContext(PageContext);
  };